import React, { useState } from "react";
import { Upload, Button } from "antd";
import { InboxOutlined, CheckCircleFilled, SyncOutlined } from "@ant-design/icons";
import "../../styles/compareWizard.css";

const { Dragger } = Upload;

const formatSize = (bytes) => {
  if (bytes == null) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

// Reusable drag-and-drop file picker (AntD Dragger) for the compare wizards.
// `beforeUpload` returns false so AntD never uploads — the caller reads the
// File object itself (FileReader). Once a file is chosen it shows a prominent
// "selected" state with a Replace action instead of the tiny default list.
//   <FileDropzone onFile={(f) => ...} accept=".csv,.txt" hint="..." />
function FileDropzone({ onFile, accept, hint }) {
  const [file, setFile] = useState(null);

  const selectFile = (f) => {
    setFile(f);
    onFile(f);
    return false;
  };

  if (file) {
    return (
      <div className="cmp-file-selected">
        <CheckCircleFilled className="cmp-file-check" />
        <div className="cmp-file-meta">
          <div className="cmp-file-name">{file.name}</div>
          <div className="cmp-file-sub">{formatSize(file.size)} · ready to compare</div>
        </div>
        <Upload
          showUploadList={false}
          maxCount={1}
          accept={accept}
          beforeUpload={selectFile}
        >
          <Button type="text" size="small" icon={<SyncOutlined />} className="cmp-file-replace">
            Replace
          </Button>
        </Upload>
      </div>
    );
  }

  return (
    <Dragger
      className="cmp-dropzone"
      maxCount={1}
      multiple={false}
      accept={accept}
      showUploadList={false}
      beforeUpload={selectFile}
    >
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">Click or drag a file here to upload</p>
      {hint && <p className="ant-upload-hint">{hint}</p>}
    </Dragger>
  );
}

export default FileDropzone;
